import { createApi } from '@reduxjs/toolkit/dist/query/react'
import { createBaseQuery } from '../helper/createBaseQuery'
import { validateQueryStringParameters } from '../../helpers/api'
// import { tokenSlice } from "../slice/tokenSlice";

const orderApi = createApi({
  reducerPath: 'order',
  baseQuery: createBaseQuery(),
  tagTypes: ['Order'],
  endpoints(builder) {
    return {
      // GET
      getOrderType: builder.query({
        query: (id) => ({
          url: `Order/Type/${id}`,
          method: 'GET',
        }),
        providesTags: ['Order'],
      }),

      getOrderHeaderload: builder.query({
        query: (id) => ({
          url: `Order/GetHeaderLoad/${id}`,
          method: 'GET',
        }),
        providesTags: ['Order'],
      }),

      getOrderCard: builder.query({
        query: () => ({
          url: `Order/GetOrderCard`,
          method: 'GET',
        }),
        providesTags: ['Order'],
      }),

      postOrderAll: builder.mutation({
        query: (data) => ({
          url: 'Order/GetAll',
          method: 'POST',
          body: data,
        }),
        invalidatesTags: ['Order'],
      }),

      postOrderWFA: builder.mutation({
        query: (data) => ({
          url: 'Order/GetWFA',
          method: 'POST',
          body: data,
        }),
        invalidatesTags: ['Order'],
      }),

      postOrderChangeApproval: builder.mutation({
        query: (data) => ({
          url: 'Order/GetChangeApproval',
          method: 'POST',
          body: data,
        }),
        invalidatesTags: ['Order'],
      }),

      postOrderGetHeld: builder.mutation({
        query: (data) => ({
          url: 'Order/GetHeld',
          method: 'POST',
          body: data,
        }),
        invalidatesTags: ['Order'],
      }),

      postOrderGetRejected: builder.mutation({
        query: (data) => ({
          url: 'Order/GetRejected',
          method: 'POST',
          body: data,
        }),
        invalidatesTags: ['Order'],
      }),

      postOrderGetDraft: builder.mutation({
        query: (data) => ({
          url: 'Order/GetDraft',
          method: 'POST',
          body: data,
        }),
        invalidatesTags: ['Order'],
      }),

      postOrderAdd: builder.mutation({
        query: (data) => ({
          url: 'Order/Add',
          method: 'POST',
          body: data,
        }),
        invalidatesTags: ['Order'],
      }),

      deleteOrder: builder.mutation({
        query: (data) => ({
          url: 'Order/Delete',
          method: 'POST',
          body: data,
        }),
        invalidatesTags: ['Order'],
      }),

      getRequestList: builder.mutation({
        query: (data) => ({
          url: 'Order/GetOrderCreateListForRequest',
          method: 'POST',
          body: data,
        }),
        invalidatesTags: ['Order'],
      }),

      getBIDsList: builder.mutation({
        query: (data) => ({
          url: 'Order/GetOrderCreateListForBids',
          method: 'POST',
          body: data,
        }),
        invalidatesTags: ['Order'],
      }),

      postOrderSave: builder.mutation({
        query: (data) => ({
          url: 'Order/Save',
          method: 'POST',
          body: data,
        }),
        invalidatesTags: ['Order'],
      }),

      postOrderSendToApprove: builder.mutation({
        query: (data) => ({
          url: 'Order/SendToApprove',
          method: 'POST',
          body: data,
        }),
        invalidatesTags: ['Order'],
      }),

      postOrderChangeStatus: builder.mutation({
        query: (data) => ({
          url: 'Order/ChangeOrderMainStatus',
          method: 'POST',
          body: data,
        }),
        invalidatesTags: ['Order'],
      }),

      getTaxData: builder.query({
        query: (vendorId) => ({
          url: `Order/GetWithHoldingTaxData/${vendorId}`,
          method: 'GET',
        }),
        providesTags: ['Order'],
      }),

      getBaseAndReportCurrencyRate: builder.query({
        query: (params) => {
          return {
            url: `General/GetBaseAndReportCurrencyRate`,
            params: validateQueryStringParameters(params),
          }
        },
        providesTags: ['Order'],
      }),

      postOrderRetrieve: builder.mutation({
        query: (data) => {
          return {
            url: `Order/Retrieve`,
            method: 'POST',
            body: data,
          }
        },

        providesTags: ['Order'],
      }),

      postAnalysisByCode: builder.mutation({
        query: (data) => ({
          url: 'Order/GetAnalysisByCode',
          method: 'POST',
          body: data,
        }),
        invalidatesTags: ['Order'],
      }),

      getOrderAttachments: builder.query({
        query: (params) => {
          return {
            url: `Attachment/GetOrderAttachments`,
            params: validateQueryStringParameters(params),
          }
        },

        providesTags: ['Request'],
      }),
    }
  },
})

export const {
  useGetOrderTypeQuery,
  useDeleteOrderMutation,
  usePostOrderAddMutation,
  usePostOrderAllMutation,
  usePostOrderChangeApprovalMutation,
  usePostOrderWFAMutation,
  usePostOrderGetRejectedMutation,
  usePostOrderGetDraftMutation,
  usePostOrderGetHeldMutation,
  useGetRequestListMutation,
  useGetBIDsListMutation,
  useGetOrderCardQuery,
  usePostOrderSaveMutation,
  usePostOrderSendToApproveMutation,
  useGetOrderHeaderloadQuery,
  useGetTaxDataQuery,
  useGetBaseAndReportCurrencyRateQuery,
  usePostOrderChangeStatusMutation,
  usePostOrderRetrieveMutation,
  usePostAnalysisByCodeMutation,
  useGetOrderAttachmentsQuery,
} = orderApi

export { orderApi }